import { createFileRoute } from "@tanstack/react-router";
import ImpersonateUser from "../../../features/admin/components/ImpersonateUser";

const ImpersonateUsersPage = () => {
    return <ImpersonateUser />;
};
export const Route = createFileRoute("/_app/admin/impersonate-user")({
    component: ImpersonateUsersPage,
});
